<script setup lang="ts">
    import { defineProps } from 'vue';
    import { useRoute } from "vue-router";

    const route = useRoute();
    const campusName = route.meta.nombre || "";

    interface Props {
        frase: string,
        autor: string,
        line1?: string,
        line2?: string,
        line3?: string,
        line4?: string,
        line5?: string,
        line6?: string,
        mapslink: string,
    }

    defineProps<Props>();
</script>

<template>
    <section id="leyenda" class="lg:container mx-auto max-w-4xl lg:max-w-6xl mb-8">
        <div class="bg-black/70 text-white w-full p-4 rounded-lg">
            <p class="text-left text-xl font-bold">
                Bienvenidos
            </p>
            <p class="text-justify mt-6 p-2 lg:p-0">
                Te damos la m&aacute;s cordial bienvenida a nuestro <span class="font-bold">{{ campusName }}</span>, en donde podr&aacute;s encontrar un sin fin de opciones para alcanzar tus metas y lograr el &eacute;xito que buscas a trav&eacute;s del esfuerzo, el estudio y la dedicaci&oacute;n que solo t&uacute; puedes darle a tus sueños.
            </p>
            <p class="self-end italic mt-2 p-2 md:p-0 w-full text-right">
                "{{ frase }}" - {{ autor }}
            </p>
        </div>
    </section>

    <section id="ubicacion" class="container mx-auto max-w-4xl lg:max-w-6xl lg:mb-8">
            <div class="flex flex-col md:flex-row justify-center items-center font-montse lg:mt-14 md:px-4 w-full">
                <div class="flex flex-col items-center md:items-start w-full md:w-2/5 font-montse text-center md:text-left pb-6 pl-2 md:pb-0 lg:pl-0">
                    <h1 v-if="line1" class="text-2xl">
                        {{ line1 }}
                    </h1>
                    <p v-if="line2" >
                        {{ line2 }}
                    </p>
                    <p v-if="line3" >
                        {{ line3 }}
                    </p>
                    <p v-if="line4" >
                        {{ line4 }}
                    </p>
                    <p v-if="line5" >
                        {{ line5 }}
                    </p>
                    <p v-if="line6" >
                        {{ line6 }}
                    </p>
                </div>
                <div class="w-full md:w-3/5">
                    <iframe :src="mapslink" class="w-full h-[300px]" style="border:0;" allowfullscreen loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                </div>
            </div>
        </section>
</template>

<style scoped>
</style>